// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OptionCalculatorModel;
(function (OptionCalculatorModel) {
    OptionCalculatorModel[OptionCalculatorModel["BlackSholes"] = 0] = "BlackSholes";
})(OptionCalculatorModel || (OptionCalculatorModel = {}));
